class BaseError extends Error {
    detailedInfo;
    statusCode;
}

export class ChangingRoleForOwnerError extends BaseError {
    constructor() {
        super();
        this.statusCode = 409;
        this.message = "changingRoleForOwnerError";
    }
}

export class OwnerAlreadyExistsError extends BaseError {
    constructor() {
        super();
        this.statusCode = 409;
        this.message = "ownerAlreadyExists";
    }
}

export class DenyDeleteOwnerError extends BaseError {
    constructor() {
        super();
        this.statusCode = 409;
        this.message = "denyDeleteOwnerError";
    }
}

export class UserAlreadyExistsError extends BaseError {
    constructor() {
        super();
        this.statusCode = 409;
        this.message = "userAlreadyExists";
    }
}

export class ProjectAlreadyExistsError extends BaseError {
    constructor() {
        super();
        this.statusCode = 409;
        this.message = "projectAlreadyExists";
    }
}

export class UserNotFoundError extends BaseError {
    constructor() {
        super();
        this.statusCode = 409;
        this.message = "userNotFound";
    }
}

export class ResourceNotFoundError extends BaseError {
    constructor() {
        super();
        this.statusCode = 409;
        this.message = "resourceNotFound";
    }
}

export class ProjectNotFoundError extends BaseError {
    constructor() {
        super();
        this.statusCode = 409;
        this.message = "projectNotFound";
    }
}

export class LanguageNotFoundError extends BaseError {
    constructor() {
        super();
        this.statusCode = 409;
        this.message = "languageNotFound";
    }
}

export class TaskNotFoundError extends BaseError {
    constructor() {
        super();
        this.statusCode = 409;
        this.message = "taskNotFound";
    }
}

export class ResourceForTaskNotFoundError extends BaseError {
    constructor() {
        super();
        this.statusCode = 409;
        this.message = "resourceForTaskNotFound";
    }
}

export class VerificationCodeNotRequestedError extends BaseError {
    constructor() {
        super();
        this.statusCode = 409;
        this.message = "verificationCodeNotRequested";
    }
}

export class LanguageIsNotAddedToProjectError extends BaseError {
    constructor() {
        super();
        this.statusCode = 409;
        this.message = "languageIsNotAddedToProject";
    }
}

export class MultiLangIsNotSupportedError extends BaseError {
    constructor() {
        super();
        this.statusCode = 400;
        this.message = "multiLangIsNotSupportedError";
    }
}

export class ValidationError extends BaseError {
    constructor(detailedInfo) {
        super();
        this.statusCode = 422;
        this.message = "validationError";
        this.detailedInfo = detailedInfo;
    }
}

export class UserUnauthorizedError extends BaseError {
    constructor() {
        super();
        this.statusCode = 401;
        this.message = "userUnauthorizedError";
    }
}

export class WrongPasswordError extends BaseError {
    constructor() {
        super();
        this.statusCode = 401;
        this.message = "wrongPasswordError";
    }
}

export class ForbiddenError extends BaseError {
    constructor() {
        super();
        this.statusCode = 403;
        this.message = "forbiddenError";
    }
}

export class UserNotVerifiedError extends BaseError {
    constructor() {
        super();
        this.statusCode = 403;
        this.message = "userNotVerifiedError";
    }
}

export class FileToBigError extends BaseError {
    constructor() {
        super();
        this.statusCode = 409;
        this.message = "fileToBig";
    }
}

export class UnsupportedFileFormatError extends BaseError {
    constructor() {
        super();
        this.statusCode = 409;
        this.message = "unsupportedFileFormat";
    }
}

export class NeedGoogleDocAuthError extends BaseError {
    constructor() {
        super();
        this.statusCode = 409;
        this.message = "needGoogleDocAuth";
    }
}
